import { render, staticRenderFns } from "./DeliveryPointsInputModeForm.vue?vue&type=template&id=c1ce685c&scoped=true&"
import script from "./DeliveryPointsInputModeForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryPointsInputModeForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPointsInputModeForm.vue?vue&type=style&index=0&id=c1ce685c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ce685c",
  null
  
)

export default component.exports